module.exports = __webpack_public_path__ + "static/furniture-listlink-banner-right-section-code-2b08cfbd80ff468209377969d52c351c.png";